<div class="animated fadeIn search-result">
    <div>
        <div class="filter-area">
            <app-filter-list [plantingSites]="unfilteredSites"
                             class="filter-list">
                <button class="btn filter-close" (click)="toggleFilterActive()">
                    <i class="filter-icon"></i> FILTER
                    <i class="close-icon"></i>
                </button>
                <div class="form-group search">
                    <form class="input-group">
                        <input class="form-control"
                               [(ngModel)]="searchText"
                               name="search"
                               placeholder="Search"
                               [ngModelOptions]="{updateOn: 'submit'}"
                               (ngModelChange)="searchChanged()">
                        <span class="input-group-append">
                            <button class="btn btn-primary" type="submit">
                                <i class="icon-magnifier"></i>
                            </button>
                        </span>
                    </form>
                    <p>By planting site, certificate, name, or customer ID</p>
                </div>
            </app-filter-list>
        </div>
    </div>


    <div class="search-result-box">
        <div class="row">
            <div class="col-12">
                <h3 class="header-3">Planting sites</h3>
            </div>
            <div class="col-12">
                <div class="button-area">
                    <div class="filter-button">
                        <span>{{siteCount}} sites found</span>
                        <button class="btn btn-outline-primary-dark" type="button" (click)="toggleFilterActive()">
                            <i class="filter-icon"></i> Show filter
                        </button>
                    </div>
                    <div class="layout-view-button" [class.d-none]="isGridPage">
                        <button class="btn btn-outline-primary"
                            [routerLink]="['grid']"
                            [replaceUrl]="true"
                            queryParamsHandling="preserve">
                            <i class="grid-icon"></i><span>Switch to grid view</span>
                        </button>
                    </div>
                    <div class="map-view-button" [class.d-none]="!isGridPage">
                        <div class="btn-group" dropdown>
                            <button id="button-basic" dropdownToggle 
                                    type="button" 
                                    class="btn btn-outline-primary dropdown-toggle"
                                    aria-controls="dropdown-basic">
                                    {{getSortDescription(isNewest)}}<span class="caret"></span>
                            </button>
                            <ul id="dropdown-basic" *dropdownMenu 
                                class="dropdown-menu"
                                aria-labelledby="button-basic">
                              <li *ngFor="let sort of sortDirections"
                                (click)="navigateSortSites(sort.value); isNewest = sort.value"><a class="dropdown-item">{{sort.description}}</a></li>
                            </ul>
                        </div>                        
                        <button class="btn btn-outline-primary" 
                                [routerLink]="['map']"
                                [replaceUrl]="true"
                                queryParamsHandling="preserve">
                            <i class="map-icon"></i><span>Switch to map view</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
</div>
